import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const defaultItems: BreadcrumbItem[] = [
    { label: '首页', path: '/' },
  ];

  const breadcrumbItems = items ? [...defaultItems, ...items] : defaultItems;

  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
      {breadcrumbItems.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-300 text-sm" />
          )}
          {item.path && index < breadcrumbItems.length - 1 ? (
            <Link
              to={item.path}
              className="text-foreground-400 hover:text-primary-500 transition-colors duration-150 whitespace-nowrap cursor-pointer"
            >
              {item.label}
            </Link>
          ) : (
            <span className={index === breadcrumbItems.length - 1 ? 'text-foreground-700 font-medium' : 'text-foreground-400'}>
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}